import angular from 'angular';
import UIRouter from 'angular-ui-router';

import createStub from '../olr-common/createStub';
import './styles/index.scss';
import template from './index.html';
import AttendanceController from './AttendanceController';
    
    let namespace = angular.module('olr-mainfe-attendance', [
      UIRouter,
      'olr-common'
    ]);

    namespace.config(function($stateProvider) {
      $stateProvider.state('olr.mainfe.attendance', {
        url: '/attendance/:classRoomName?date&cId',
        controller: AttendanceController,
        controllerAs : 'ctrl',
        template: template
      });
    });

    namespace.controller('AttendanceController', AttendanceController);

    export default namespace.name;




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-attendance/index.js
 **/